// extracted by mini-css-extract-plugin
export default {"block":"WebhookInfo_block__z8Lj6"};